<mat-toolbar class="main-toolbar" role="banner">
  <mat-toolbar-row>
    <span class="logo-wrapper">
      <a class="title" routerLink="/">
        <img class="logo" src="/assets/az_icon.svg" alt="AZ logo" />
        <span>Cerberus</span>
      </a>
    </span>
    <span class="fill-remaining-space"></span>
    <span class="user-wrapper">
      <img
        src="https://adhoc.rd.astrazeneca.net/api/thumbs/{{
          userData.prid
        }}?appid=cerberus"
        alt="user picture"
        *ngIf="userData.prid"
      />
      <span class="username">{{ userData.name }}</span>
    </span>
  </mat-toolbar-row>
</mat-toolbar>
